import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import CardMedia from '@material-ui/core/CardMedia';
import { Button } from '@material-ui/core';
import approved from '../../assets/images/Approved.png'
import { showToast } from '../../Utils/index'

const useStyles = makeStyles({
  root: {},
  media: {
    minHeight: 240,
    maxHeight: 250,
    cursor: 'pointer',
  },
  listItems: {
    paddingTop: 10, paddingBottom: 10, paddingLeft: 10, paddingRight: 10,
  },
  cancel: {
    position: 'absolute',
    top: 5,
    right: 0,
    zIndex: 1,
    fontWeight: 'bold',
    color: '#9c27b0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  btn: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    minWidth: '40px',
    height: '36px',
    boxShadow: 'none !important',
    padding: 0,
    outline: 'none !important',
  },
});

const SiteCarouselSlide = ({
  index,
  media,
  approvedMedia,
  openLightBox,
}) => {
  const classes = useStyles();

  const copyURL = (url) => {
    navigator.clipboard.writeText(url);
    showToast('info', 'URL copied');
  }

  return (
    <div>
      {media.status === 'approved' && approvedMedia === media.url
        ? (
          <div className={classes.cancel}>
            <img src={approved} alt="approved" width="130" />
            <Tooltip title="Copy approved image url" placement="top">
              <Button className={classes.btn} variant="contained" color="primary" onClick={() => copyURL(media.url)}>
                <FileCopyIcon fontSize="small" />
              </Button>
            </Tooltip>
          </div>
        )
        : null}
      {media.type === 'video'
        ? (
          <CardMedia
            className={classes.media}
            image={media.url}
            controls
            media={media.type}
            type="video/mp4"
            muted={false}
            autoPlay
            title="Contemplative Reptile"
            component="video"
          />
        )
        : (
          <CardMedia
            className={classes.media}
            image={media.url}
            media={media.type}
            title="Contemplative Reptile"
            onClick={() => openLightBox(index)}
          />
        )}
    </div>
  );
}

export default SiteCarouselSlide;
